@if(!pathService.isInPrintReceipt() && !pathService.isInQrPayment()){
  <a
    class="skip-to-content"
    [attr.tabindex]="modalService.isModalOpen() ? -1 : 0"
    [attr.aria-hidden]="modalService.isModalOpen() ? 'true' : null"
    [attr.inert]="modalService.isModalOpen() ? '' : null"
    href="#main-content"
    (click)="onSkipToMain($event)"
    *transloco="let t"
  >{{t('route.menu.skip_to_content')}}</a>  
  <header
    id="header"
    [attr.tabindex]="modalService.isModalOpen() ? -1 : 0"
    [attr.aria-hidden]="modalService.isModalOpen() ? 'true' : null"
    [attr.inert]="modalService.isModalOpen() && layoutService.mobileView() ? '' : null"
  >
    @if(storeStatusForBanner() && storeStatusForBanner()?.statusMessage){
      <section class="top-banner" id="top-banner">
        <cwo-top-banner [storeStatus]="storeStatusForBanner()"/>
      </section>
    }
    @if(showBanner()) {
      <section class="app-banner" id="app-banner">
        <cwo-app-banner />
      </section>
    }
    <section class="main-header" id="main-header">
      <cwo-header-layout />
    </section> 
  </header>
}

@if(pathService.isInQrPayment()){
  <header
    id="header"
    [attr.tabindex]="modalService.isModalOpen() ? -1 : 0"
    [attr.aria-hidden]="modalService.isModalOpen() ? 'true' : null"
    [attr.inert]="modalService.isModalOpen() ? '' : null"
  >
    <section class="main-header only-logo" id="main-header">
      <cwo-header-logo [staticSiteUrl]="store?.staticSiteUrl ?? ''" [logoRedirectToStaticSite]="!!store?.logoRedirectToStaticSite" [src]="store?.logo" [altText]="store?.altText"></cwo-header-logo>
    </section> 
  </header>
}

<main
  id="main-content"
  tabindex="-1"
  [attr.aria-hidden]="modalService.isModalOpen() ? 'true' : null"
  [attr.inert]="modalService.isModalOpen() ? '' : null"
>
  <router-outlet></router-outlet>
</main>

<cwo-modals />

@if(!pathService.isInPrintReceipt() && !pathService.isInQrPayment()){
  <footer
    class="footer"
    [attr.aria-hidden]="modalService.isModalOpen() ? 'true' : null"
    [attr.inert]="modalService.isModalOpen() ? '' : null"
    tabindex="-1"
  >
    <cwo-footer />
  </footer>
}